import React, { useEffect, useState } from "react";
import "./agentmodal.css";
import { Modal } from "react-bootstrap";
import { message, Select, Spin } from "antd";
import Instance from "../../../AxiosConfig";

const AddAgentModal = ({ show, handleClose, fetchData }) => {
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [target, setTarget] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [joiningDate, setJoiningDate] = useState("");

  const [managerData, setManagerData] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);

  /* ---------------- FETCH MEMBERS ---------------- */
  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await Instance.get("/agents/managers");
        console.log("Members fetch response:", res.data);
        if (res?.data?.managers) {
          setManagerData(res.data.managers);
        }
      } catch (err) {
        console.error("Members fetch error:", err);
        message.error("Failed to load members");
      }
    };

    fetchMembers();
  }, []);
  /* ---------------- DROPDOWN OPTIONS ---------------- */
  const memberOptions = managerData.map((member) => ({
    label: member.agentName,   // change if API uses fullName
    value: member._id,    // send ID to backend
  }));
  /* ---------------- SAVE AGENT ---------------- */
  const handleSave = async () => {
  setSubmitted(true);

  try {
    setLoading(true);

    // ✅ Prepare payload
    const payload = {
      agentName: name,
      agentEmail: email,
      agentNumber: mobileNumber,
      role: "AGENT",
      parentAgentId:selectedMembers,
      joiningDate: joiningDate || undefined,
    };

   
    const response = await Instance.post("/agents", payload);

    console.log("API response:", response.data); // also useful

    if (response.status === 200 || response.status === 201) {
      message.success("New Agent added successfully!");

      handleClose();

      setName("");
      setEmail("");
      setMobileNumber("");
      setTarget("");
      setSelectedMembers([]);
      setSubmitted(false);
      setJoiningDate("");

      fetchData();
    }
  } catch (error) {
  console.error("Add agent error:", error?.response?.data);

  const errorData = error?.response?.data;

  if (error?.response?.status === 409) {
    if (errorData?.duplicateType === "EMAIL") {
      message.error(
        `Email already exists for ${errorData?.conflictingAgent?.agentName}`
      );
    } else if (errorData?.duplicateType === "NUMBER") {
      message.error(
        `Mobile number already exists for ${errorData?.conflictingAgent?.agentName}`
      );
    } else {
      message.error(errorData?.message);
    }

    return;
  }

  message.error("Failed to add agent");
} finally {
    setLoading(false);
  }
};

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="custom-agent-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Agent</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="container-fluid">
            <div className="row">

              {/* Agent Name */}
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Agent Name
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className={`form-control ${
                    submitted && !name ? "input-error" : ""
                  }`}
                  placeholder="Enter agent name"
                />
              </div>

              {/* Email */}
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Email 
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`form-control ${
                    submitted && !email ? "input-error" : ""
                  }`}
                  placeholder="Enter email"
                />
              </div>

              {/* Mobile */}
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Mobile Number
                </label>
               <input
  type="tel"
  value={mobileNumber}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");

    if (value.length <= 10) {
      setMobileNumber(value);
    }
  }}
  className={`form-control ${
    submitted &&
    (!mobileNumber || !/^\d{10}$/.test(mobileNumber))
      ? "input-error"
      : ""
  }`}
  placeholder="Enter 10-digit mobile number"
/>
              </div>

              <div className="col-md-12 mb-3">
  <label className="form-label">
    Joining Date
  </label>

  <input
    type="date"
    className="form-control"
    value={joiningDate}
    onChange={(e) => setJoiningDate(e.target.value)}
  />

  <small className="text-muted">
    Leave blank to use today's date.
  </small>
</div>
              

              {/* Assign To */}
              <div className="col-md-12 mb-3">
                <label className="form-label">Assign To</label>
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Select members"
                  value={selectedMembers}
                  options={memberOptions}
                  onChange={setSelectedMembers}
                  filterOption={(input, option) =>
                    option.label
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="users-discard-button"
                  onClick={handleClose}
                >
                  Discard
                </button>

                <button
                  type="button"
                  className="users-save-button d-flex align-items-center justify-content-center"
                  onClick={handleSave}
                  disabled={loading}
                  style={{ minWidth: "110px" }}
                >
                  {loading ? (
                    <>
                      <Spin size="small" /> &nbsp;Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>

            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddAgentModal;
